import type { LiveStreamQuota, MemberSettings } from '@/models/interface/member';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class MemberService extends ApiFactory {
  constructor() {
    super('Member');
  }

  /**
   *  檢查是否有重複上課
   *
   * @param customer_id 固定411
   */
  checkRepeatClass(class_cname: string): Promise<ApiDataResponse<boolean>> {
    return super.get(`CheckRepeatClass?customer_id=411&class_cname=${class_cname}`);
  }

  /**
   *  檢查是否有展延過
   */
  isExtensionShow(): Promise<ApiDataResponse<boolean>> {
    return super.get('ExtensionShow');
  }

  /**
   *  送出展延
   */
  setExtensionShow(): Promise<ApiDataResponse<boolean>> {
    return super.postNoData('Extension');
  }

  /**
   * 取得會員平台功能設定
   * @returns
   */
  settings(): Promise<ApiDataResponse<MemberSettings>> {
    return super.get('Settings');
  }

  /**
   * 領取兩張上課券
   */
  withdrawTicket(): Promise<ApiDataResponse<boolean>> {
    return super.postNoData('WithdrawTicket');
  }

  /**
   * 使用直播卷
   */
  useTicket(sourceId: string): Promise<ApiDataResponse<LiveStreamQuota>> {
    return super.postNoData('UseTicket', undefined, { params: { sourceId } });
  }

  /**
   * 剩餘券數
   */
  getRemainingTickets(): Promise<ApiDataResponse<{ courseTickets: number; liveStreamTickets: number }>> {
    return super.get('RemainingTickets');
  }
}
